var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.707 11.2929L15.707 4.29292C15.5184 4.11076 15.2658 4.00997 15.0036 4.01224C14.7414 4.01452 14.4906 4.11969 14.3052 4.3051C14.1198 4.49051 14.0146 4.74132 14.0123 5.00352C14.01 5.26571 14.1108 5.51832 14.293 5.70692L19.586 10.9999H2C1.73478 10.9999 1.48043 11.1053 1.29289 11.2928C1.10536 11.4803 1 11.7347 1 11.9999C1 12.2651 1.10536 12.5195 1.29289 12.707C1.48043 12.8946 1.73478 12.9999 2 12.9999H19.586L14.293 18.2929C14.1975 18.3852 14.1213 18.4955 14.0689 18.6175C14.0165 18.7395 13.9889 18.8707 13.9878 19.0035C13.9866 19.1363 14.0119 19.268 14.0622 19.3909C14.1125 19.5138 14.1867 19.6254 14.2806 19.7193C14.3745 19.8132 14.4862 19.8875 14.609 19.9377C14.7319 19.988 14.8636 20.0133 14.9964 20.0122C15.1292 20.011 15.2604 19.9834 15.3824 19.931C15.5044 19.8786 15.6148 19.8024 15.707 19.7069L22.707 12.7069C22.8945 12.5194 22.9998 12.2651 22.9998 11.9999C22.9998 11.7348 22.8945 11.4804 22.707 11.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.9d17b148fd32dbc77618fd7b5e9c471e.svg";
export { ForwardRef as ReactComponent };